import { defineMessages } from 'react-intl';

// TODO: Improve this, they should be defined in an errorFallbackUI specific to their implementation
// https://hello.jira.atlassian.cloud/browse/NAVX-2886
export const defaultMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.default',
		defaultMessage: 'We couldn’t load this content',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.default',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const customizationMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.customization-modal',
		defaultMessage: 'We couldn’t load your customization options',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.customization-modal',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const moreMenuMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.global-more-menu',
		defaultMessage: 'We couldn’t load more options',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-more-menu',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const sideNavMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.global-side-navigation',
		defaultMessage: 'We couldn’t load the sidebar',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-side-navigation',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const sideNavItemActionsMenuMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.global-side-navigation-nav-item-actions',
		defaultMessage: 'We couldn’t load more actions',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-side-navigation-nav-item-actions',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const dndMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.ui.header.drag-and-drop',
		defaultMessage: 'We couldn’t complete this action',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.ui.description.drag-and-drop',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const shortcutsMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.global-shortcuts',
		defaultMessage: 'We couldn’t load the app {uuId}',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-shortcuts',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const sideNavMainItemMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.gsn-main-nav-item',
		defaultMessage: 'We couldn’t load the item {uuId}',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.gsn-main-nav-item',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const moreMenuItemMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.global-more-menu-item',
		defaultMessage: 'We couldn’t load {uuId} in more options',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-more-menu-item',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});
